import { render, staticRenderFns } from "./Convocatorias_nombramiento.vue?vue&type=template&id=68a9639d&scoped=true&"
import script from "./Convocatorias_nombramiento.vue?vue&type=script&lang=js&"
export * from "./Convocatorias_nombramiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a9639d",
  null
  
)

export default component.exports